import React, { memo, Fragment } from 'react';
import styled from 'styled-components';
import numeral from 'numeral';
import ImageFadeIn from 'react-image-fade-in';
import optionsForProductSummary from '../../OrderSummaryCart/ProductSummaryCart/utils/optionsForProductSummary';
import renderSelectedItemsString from '../../../utils/renderSelectedItemsString';
// import ProductEditAndQuantityCartContainer from './ProductEditAndQuantityCart/ProductEditAndQuantityCartContainer';
import appConfig from '../../../../app-config';

import { Subhead, Caption2, Body } from '../../../components/Typography';
import CalorieString from '../../../components/CalorieString';

const Wrapper = styled.div`
  /* margin: ${(props) =>
    props.isForPreview ? '24px 20px' : '24px 80px 24px 80px'}; */
  display: grid;
  grid-template-columns: ${(props) =>
    props.isForPreview ? '116px 1fr' : '145px 1fr'};
  align-items: flex-start;
  grid-gap: 14px 24px;
  padding-bottom: 30px;
  border-bottom: ${(props) =>
    props.isLastProductInCart
      ? 'none'
      : `2px solid ${props.theme.productSummaryBorderColor}`};
  margin-bottom: ${(props) => (props.isForPreview ? '420pxpx' : 'unset')};
  @media (max-width: 786px) {
    grid-template-columns: 80px 1fr;
  }
`;

const TitleAndPriceWrapper = styled.div`
  display: grid;
  grid-column: ${(props) => (props.isNoImage ? 'span 2' : '1fr 1fr 1fr')};
  align-content: stretch;
  align-self: stretch;
`;

const ProductTitle = styled(Subhead)`
  text-transform: uppercase;
`;

const ProductImage = styled(ImageFadeIn)`
  width: 70px;
  height: 70px;
  object-fit: cover;
  border-radius: 50%;
`;

const OptionWrapper = styled.div`
  display: flex;
  padding: 5px 0;
  @media (max-width: 786px) {
    grid-template-columns: 80px 1fr;
  }
`;

const Label = styled(Caption2)`
  color: #000000;
  font-size: 14px;
  font-weight: 600;
`;

// const Price = styled(Caption1)`
//   color: ${props => props.theme.darkGray};
//   justify-self: flex-end;
// `;

const Text = styled(Caption2)`
  text-transform: capitalize;
  margin-left: 4px;
  margin-top: 2px;
  span {
    font-size: 14px;
    font-weight: 500;
  }
`;

const EditQuantityRow = styled.div`
  grid-column: span 2;
`;

const Price = styled(Body)`
  color: #737a87;
  font-size: 15px;
  font-weight: 600;
`;

const CalPriceRow = styled.div`

  display: grid;
  grid-template-columns: auto  auto; 
  grid-gap: 6px;
  align-items: center;
  // justify-content: ${(props) => (props.cals ? 'space-between' : 'flex-end')};
  // align-self: flex-end;
  margin-top: 4px;
  grid-column: ${(props) => (props.isForPreview ? 'span 2' : 'auto')};
  grid-column-start: ${(props) => (props.isForPreview ? '0' : '2')};
`;
const NoteWraper = styled.div`
  width: 100%;
  margin: 0 5px 20px 0;
`;
const NoteLabel = styled.span`
  width: 100%;
  height: 17px;
  margin: 0 4px 15px 0;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.02px;
  color: var(--colors-basic-dark);
`;
const NoteText = styled.span`
  width: 100%;
  height: 17px;
  white-space: pre-line;
  margin: 0 0 0 4px;
  font-family: Inter;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.02px;
  color: var(--colors-basic-dark);
`;
const Dot = () => (
  <i
    style={{ fontSize: '3px', textAlign: 'center' }}
    className='fas fa-circle'
  />
);
const TitleIconWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
const ProductPreview = ({
  productInCart,
  isLastProductInCart,
  isForPreview,
  validatedCart,
  products,
}) => {
  return (
    <div>
      {products?.map((productInCart, index) => {
        const { flatProduct, totalPrice, singlePrice } = productInCart;

        return (
          <Wrapper
            key={index}
            isLastProductInCart={isLastProductInCart}
            isForPreview={isForPreview}
          >
            {!appConfig.isNoImage && (
              <ProductImage src={flatProduct.image_url} />
            )}
            <TitleAndPriceWrapper isNoImage={appConfig.isNoImage}>
              <ProductTitle id='ProductPreview-ProductTitle'>
                <TitleIconWrapper>
                  <div>{flatProduct.name}</div>
                </TitleIconWrapper>
                {flatProduct.quantity > 1 && (
                  <span style={{ textTransform: 'lowercase' }}>
                    {' '}
                    x{flatProduct.quantity}
                  </span>
                )}
                {!isForPreview && (
                  <CalPriceRow cals isForPreview={isForPreview}>
                    <Price id='ProductPreview-Price'>
                      {numeral(singlePrice).format('$0.00')}
                    </Price>
                    {flatProduct.calories ? (
                      <Fragment>
                        <CalorieString
                          id='ProductPreview-Calories'
                          calories={flatProduct.calories.find(
                            (calorie) =>
                              calorie.variant_id === flatProduct.variant_id
                          )}
                        />
                      </Fragment>
                    ) : (
                      <div />
                    )}
                  </CalPriceRow>
                )}
              </ProductTitle>
            </TitleAndPriceWrapper>
            {isForPreview && (
              <CalPriceRow cals isForPreview={isForPreview}>
                <Price id='ProductPreview-Price'>
                  {numeral(singlePrice).format('$0.00')}
                </Price>
                {flatProduct.calories ? (
                  <Fragment>
                    <Dot />
                    <CalorieString
                      id='ProductPreview-Calories'
                      calories={flatProduct.calories.find(
                        (calorie) =>
                          calorie.variant_id === flatProduct.variant_id
                      )}
                    />
                  </Fragment>
                ) : (
                  <div />
                )}
              </CalPriceRow>
            )}

            <div style={{ gridColumn: '1 / -1' }}>
              {flatProduct.prices?.length > 0 && (
                <OptionWrapper isForPreview={isForPreview}>
                  <Label id='ProductPreview-Size'>Size -</Label>
                  <Text>{flatProduct?.prices[0]?.name}</Text>
                </OptionWrapper>
              )}
              {optionsForProductSummary(flatProduct) &&
                optionsForProductSummary(flatProduct).map((option, index) => {
                  const isLastOption =
                    optionsForProductSummary(flatProduct).length === index + 1;
                  if (option.sub_options && option.sub_options.length) {
                    return option.sub_options.map((subOption) => {
                      return (
                        <OptionWrapper
                          isLastOption={isLastOption}
                          key={subOption.option_id}
                          isForPreview={isForPreview}
                        >
                          <Label id='ProductPreview-SubOptionName'>
                            {`${subOption.name} - `}
                          </Label>
                          <Text>
                            {renderSelectedItemsString(
                              flatProduct,
                              subOption
                            ).toLowerCase()}
                          </Text>
                        </OptionWrapper>
                      );
                    });
                  } else {
                    return (
                      <OptionWrapper
                        isLastOption={isLastOption}
                        key={option.option_id}
                        isForPreview={isForPreview}
                      >
                        <Label id='ProductPreview-OptionName'>
                          {`${option.name} - `}
                        </Label>
                        <Text>
                          {renderSelectedItemsString(
                            flatProduct,
                            option
                          ).toLowerCase()}
                        </Text>
                      </OptionWrapper>
                    );
                  }
                })}
              {flatProduct.special_instruction && (
                <NoteWraper>
                  <NoteLabel>Notes -</NoteLabel>
                  <NoteText>{flatProduct.special_instruction}</NoteText>
                </NoteWraper>
              )}
            </div>
          </Wrapper>
        );
      })}
    </div>
  );
};

export default ProductPreview;
